$(document).ready(function () {
    var $navbar = $('.theme__header');
    var lastScrollTop = 0;

    $(window).on('scroll', function () {
      var scrollTop = $(this).scrollTop();
      if (scrollTop <= 50) {
        $navbar.removeClass('active bgcolor');
      }
      // Scrolling down
      else if (scrollTop > lastScrollTop) {
        $navbar.addClass('active bgcolor');
      }
      // Scrolling up
      else if (scrollTop < lastScrollTop) {
        $navbar.removeClass('active');
      }
      lastScrollTop = scrollTop;
    });
});
gsap.registerPlugin(ScrollTrigger);
var parallax_elements = gsap.utils.toArray("[gsap-parallax]");
parallax_elements.forEach(function (element) {
  gsap.to(element, {
       yPercent: -20, 
       ease: "none",
       scrollTrigger: {
         trigger: element,
         start: "top bottom",  
         end: "bottom top",    
         scrub: true,       
       },
  });
});

var parallax_elements_block = gsap.utils.toArray("[gsap-parallax-block]");
parallax_elements_block.forEach(function (element) {
  gsap.to(element, {
       yPercent: -50, 
       ease: "none",
       scrollTrigger: {
         trigger: element,
         start: "top bottom",  
         end: "bottom top",    
         scrub: true,       
       },
  });
});

var swiperThumbs = new Swiper(".thumb-swiper", {
  spaceBetween: 8,
  slidesPerView: 4,
  freeMode: true,
  direction: 'vertical',
  loop:true,
  watchSlidesProgress: true,
  breakpoints: {
    320: { slidesPerView: 4 },
    768: { slidesPerView: 4 },
    1024: { slidesPerView: 4 },
    1440: { slidesPerView: 4 },
  },
}); 
  // Initialize Swiper
  var swiperMain = new Swiper(".swiper.main-swiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop:true,
    pagination: {
      el: ".swiper-pagination-main",
      clickable: true,
    },
    thumbs: {
    swiper: swiperThumbs,
  },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      499: { slidesPerView: 1, spaceBetween: 16 },
    },
  });


  // Initialize Magnific Popup
  $(".image-popup-vertical-fit").magnificPopup({
    type: "image",
    mainClass: "mfp-with-zoom",
    gallery: { enabled: true },
    zoom: {
      enabled: true,
      duration: 300,
      easing: "ease-in-out",
      opener: function (openerElement) {
        return openerElement.is("img") ? openerElement : openerElement.find("img");
      },
    },
  });

document.addEventListener('DOMContentLoaded', function () {
  $(function () {
    var $first = $(".accordian-topwrap").first();
    $first.addClass("open")
          .next().show()
          .parent().addClass("active");

    $(".accordian-topwrap").click(function () {
      $(".open").not(this)
        .removeClass("open")
        .next().slideUp(300)
        .parent().removeClass("active");

      $(this)
        .toggleClass("open")
        .next().slideToggle(300)
        .parent().toggleClass("active");
    });
  });
});

var other_elements = gsap.utils.toArray("[gsap-fadin-anim]");
  other_elements.forEach(function (element) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
        end: "bottom 50%",
        toggleActions: "play none none none",
      },
    });
    tl.fromTo(
      element,
      { opacity: 0, yPercent: 20 },
      { duration: 1, opacity: 1, yPercent: 0, ease: "cubic" }
  );
});